import styled from 'styled-components'

export const ErrorMessageContainer = styled.div.attrs({
  className: 'error-message',
})``

export const ErrorLoginMessageContainer = styled.div.attrs({
  className: 'error-message-login',
})``
